import { NgModule } from '@angular/core';
import { AlertMessageStoreService } from './alert-message-store.service';

@NgModule({
  providers: [AlertMessageStoreService],
})
export class AlertMessageStoreServiceModule {}
